import { useTranslation } from "react-i18next";

import { FilterOutlined, PlusOutlined } from "@ant-design/icons";
import { Flex, Row, Space, Button, Card } from "antd";
import { CardContainer } from "components/elements";
import UserRoleTable from "components/table/UserRoleTable";
import ModalRole from "./ModalRole";
import UserListFilter from "./UserListFilter";
import { useState } from "react";
import { useSelector } from "react-redux";
import { ReactComponent as CreateIcon } from "../../../assets/icon/createIcon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/icon/filterIcon.svg";

function UserRole({
  roleList = [],
  pagination = {},
  roleOptions = [],
  openModal = false,
  isLoading = false,
  initialValues = {},
  onEdit = () => { },
  onFilter = () => { },
  onCreate = () => { },
  onSubmit = () => { },
  onSearch = () => { },
  onCancel = () => { },
  onStatus = () => { },
  onPermissionSetting = () => { },
  onChange = () => { }
}) {
  const { t } = useTranslation();
  const [useFilter, setUseFilter] = useState(false);
  const { roles } = useSelector((state) => state.company);
  return (
    <>
      <ModalRole
        isModalOpen={openModal}
        roleOptions={roleOptions}
        initialValues={initialValues}
        onSubmit={onSubmit}
        onCancel={onCancel}
      />
      <Space style={{ width: "100%" }} size={24} direction="vertical">
        <Row justify="end">
          <Space size={10}>
            <Button type="default" onClick={() => setUseFilter(!useFilter)} style={{ padding: "8px 16px", height: "44px", borderRadius: "8px" }}>
              <Flex align="center" justify="center" gap={8}>
                <FilterIcon />
                <span style={{ color: "#667085" }}>{t('common.filter')}</span>
              </Flex>
            </Button>
            {
              roles.includes("CREATE_USER_MANAGEMENT|ROLE") && <Button onClick={onCreate} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "10px 16px" }} type="primary">
                <Flex align="center" justify="center" gap={8}>
                  <CreateIcon />
                  {t("common.create")}
                </Flex>
              </Button>
            }

          </Space>
        </Row>
        {useFilter && (
          <Card width="100%" style={{ border: "1px solid #EAECF0", borderRadius: "8px" }}>
            <UserListFilter
              isLoading={isLoading}
              dataSource={roleList}
              dataFlag={"role"}
              onEdit={onEdit}
              onSubmit={onSearch}
            />
          </Card>)}
        {/* <CardContainer width="100%"> */}
        <UserRoleTable

          isLoading={isLoading}
          dataSource={roleList}
          pagination={pagination}
          onChange={onChange}
          onEdit={onEdit}
          onStatus={onStatus}
          onPermissionSetting={onPermissionSetting}
        />
        {/* </CardContainer> */}
      </Space>
    </>
  );
}

export default UserRole;
